import 'react-loading-skeleton/dist/skeleton.css'
import '@rainbow-me/rainbowkit/styles.css'

import { AboutPage, IndexDetailsPage, OverviewPage, StakingIndexPage, PortfolioPage } from 'pages'
import { Navigate, Route, Routes } from 'react-router-dom'

import { Analytics } from './hooks/use-analytics'
import { AppLayout } from 'components'
import Path from 'router'
import { PrivacyPolicy } from 'pages/privacy-policy'
import React from 'react'
import { ScrollToTop } from 'hooks'
import { TermsAndConditions } from 'pages/terms-and-conditions'
import { redirectPaths } from './router'
import { walletSetup } from 'utils/address-store'
import { AccountProvider } from 'context/account'

const App: React.FC = () => {
  walletSetup()
  /**
   * Takes a list if paths to redirect from and to and returns a list of redirect routes
   * @see {redirectPaths}
   * @returns
   */
  const renderRedirects = () =>
    redirectPaths.map((path, index) => {
      return <Route key={index} element={<Navigate to={path.to} />} />
    })

  return (
    <>
      <Analytics />
      <ScrollToTop />
      <AppLayout>
        <AccountProvider />
        <Routes>
          <Route path={Path.PRODUCT_DETAILS} element={<IndexDetailsPage />} />
          <Route path={`${Path.PORTFOLIO}`} element={<PortfolioPage />} />
          <Route path={`${Path.STAKING}`} element={<StakingIndexPage />} />
          <Route path={`${Path.ABOUT}`} element={<AboutPage />} />
          <Route path={`${Path.TERMS}`} element={<TermsAndConditions />} />
          <Route path={`${Path.PRIVACY}`} element={<PrivacyPolicy />} />
          {renderRedirects()}
          <Route path={`${Path.MAIN}/*`} element={<OverviewPage />} />
          <Route path={'*'} element={<Navigate to={Path.MAIN} replace />} />
        </Routes>
      </AppLayout>
    </>
  )
}

export default App
